export default "__VITE_ASSET__B2Glsh7E__"